import { observer } from "mobx-react-lite";
import * as ST from "./styled";
import { URLHOST } from "../../../Const/envConst";
import Entrance from "../../Atoms/EntranceNew";
import EntranceMobile from "../../Atoms/EntranceNew/EntranceMobile";
import MobileMenu from "../../Atoms/NavigationMenu/MobileMenu";
import ProfileMenu from "../../../Const/ProfileMenu";
import { ReactComponent as LogoMain } from "../../../Assets/logo-main.svg";
import { ReactComponent as LogoShort } from "../../../Assets/logo-short.svg";
import { ReactComponent as LogoMobile } from "../../../Assets/logo-mobile.svg";
import { useEffect, useMemo, useState } from "react";
import { useMediaQuery } from "../../../Hooks/useMediaQuery";
import BreakPoints from "../../../../general/constants/breakPoints";
import AuthStore from "../../../Store/AuthStore";
import profileUser from "../../../Api/ProfileUserApi";
import NavigationMenu from "../../Atoms/NavigationMenu";
import programsMenuApi from "../../../Api/ProgramsMenuApi";
import defaultMenuItems from "./MenuItems";
import DataHeaderType from "../../../Types/DataHeaderType";
import HeaderStore from "../../../Store/HeaderStore";
import { ThemeProvider } from "@mui/material";
import { newLightStyles } from "src/user.InterfaceLayer/styles/theme.style";

const HeaderNew = observer(() => {
	const token = AuthStore.token;
	const storeName = AuthStore.name;
	const storeSurname = AuthStore.surname;
	const storeEmail = AuthStore.email;

	const [openProfileMenu, setOpenProfileMenu] = useState<boolean>(false);
	const [name, setName] = useState<string | undefined | null>(storeName);
	const [surname, setSurname] = useState<string | undefined | null>(
		storeSurname
	);
	const [mail, setMail] = useState<string | undefined | null>(storeEmail);
	const [menuItems, setMenuItems] =
		useState<DataHeaderType[]>(defaultMenuItems);

	const toggleOpenProfile = () => {
		setOpenProfileMenu(!openProfileMenu);
	};

	useEffect(() => {
		if (token) {
			const timer = setTimeout(() => {
				profileUser().then((e) => {
					const formattedData = e.data;

					if (formattedData)
						formattedData.countryCode =
							formattedData.countryCode?.split("_")[0] ??
							e.data?.countryCode ??
							null;

					AuthStore.setProfile(formattedData);

					if (e.data) {
						e.data.firstname &&
							localStorage.setItem("name", String(e.data.firstname));
						e.data.surname &&
							localStorage.setItem("surname", String(e.data.surname));
						e.data.loginType &&
							localStorage.setItem("loginType", String(e.data.loginType));
						e.data.id && localStorage.setItem("userId", String(e.data.id));
						e.data.status &&
							localStorage.setItem("userStatus", String(e.data.status));
						e.data.email && localStorage.setItem("email", String(e.data.email));
						e.data.photo && localStorage.setItem("photo", String(e.data.photo));
						e.data.roles &&
							localStorage.setItem("roles", JSON.stringify(e.data.roles));
						setName(e.data.firstname);
						setSurname(e.data.surname);
						setMail(e.data.email);
					}
				});
			}, 3000);
			return () => clearTimeout(timer);
		}
	}, [token, AuthStore.profileChanged]);

	const fullName = useMemo(() => `${name} ${surname}`, [name, surname]);

	const isDesktop = useMediaQuery(`(min-width: ${BreakPoints.TABLET_1023}px)`);

	useEffect(() => {
		if (!HeaderStore.getMenu()) {
			programsMenuApi().then((response) => {
				defaultMenuItems[0].children = response;
				HeaderStore.setMenu(defaultMenuItems);
			});
		} else {
			setMenuItems(HeaderStore.getMenu() ?? []);
		}
	}, []);

	return (
		// <ThemeProvider theme={newLightStyles}>
		<ST.Header>
			<ST.HeaderWrapper>
				<ST.Image href={URLHOST}>
					<LogoMain />
				</ST.Image>
				<ST.ShortLogo href={URLHOST}>
					<LogoShort />
				</ST.ShortLogo>
				<ST.MobileLogo href={URLHOST}>
					<LogoMobile />
				</ST.MobileLogo>
				<NavigationMenu data={menuItems} />
				<ST.Wrapper>
					{isDesktop ? (
						<Entrance
							fullName={name && surname ? fullName : mail}
							setMenuState={setOpenProfileMenu}
						/>
					) : (
						<EntranceMobile
							openerFunction={toggleOpenProfile}
							open={openProfileMenu}
						/>
					)}
				</ST.Wrapper>

				<MobileMenu
					data={ProfileMenu}
					open={openProfileMenu}
					onClose={setOpenProfileMenu}
				/>
			</ST.HeaderWrapper>
		</ST.Header>
		// </ThemeProvider>
	);
});

export default HeaderNew;
